<div class="col-12 my-4 card-print">
    <mat-accordion>
        <mat-expansion-panel class="filtros-panel"
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
            [expanded]="panelOpenState"
            togglePosition="before">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <mat-chip class="chip-info mr-3 div-print"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                    Detalle Errores
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row">
                <div class="col-sm-12 col-md-11 col-lg-10 mx-auto my-3" *ngFor="let item of errores">
                    <mat-card class="simple-card-error mx-auto">
                        <mat-card-header>
                            <mat-card-title class="font-size-title-card">
                                <strong>{{item?.tipo || ''}}</strong>
                            </mat-card-title>
                        </mat-card-header>
                        <mat-card-content class="px-5 py-3">
                            <div class="col-sm-12">
                                {{item?.message}}
                            </div>
                            <div class="col-sm-12">
                                <strong>Mes:</strong> {{item?.mes}} <strong>Periodo:</strong> {{item?.periodo}}
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>
